module.exports = __webpack_public_path__ + "img/administration-app.b35cf646.svg";